const state = {
  currentSound: null,
  playStatus: '',
};

const getters = {
  playStatus: state => state.playStatus,
  currentSound: state => state.currentSound,
  currentSoundId: state => (state.currentSound ? state.currentSound.id : ''),
};

const actions = {
  reset({ commit }) {
    commit('reset');
  },

  setCurrentSound({ commit }, sound) {
    commit('setCurrentSound', sound);
  },

  setPlayStatus({ commit }, status) {
    commit('setPlayStatus', status);
  },
};

const mutations = {

  setPlayStatus(state, status) {
    state.playStatus = status;
  },

  setCurrentSound(state, sound) {
    state.currentSound = sound;
  },

  reset(state) {
    state.playStatus = '';
    state.currentSound = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
